// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3qeEs","content":"Consent_content__HbGis","footer":"Consent_footer__16Chf"};